exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nature-of-suit-selector-container .nature-of-suit-selector{width:300px;display:inline-table}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/search/FormElements/NatureOfSuitOfAppellete/NatureOfSuitOfAppellete.less
 ** module id = 1078
 ** module chunks = 0
 **/